module.exports = __webpack_public_path__ + "img/chris_g_02.06e18115.jpg";